/**
 * @auth 赖传峰
 * @date 2022/4/10
 */

import { computed, useRoute } from '#imports'

export default () => {
  const route = useRoute()
  return computed(() => route.params.parent_ids?.slice(-1)[0] as string | undefined)
}
